import { Component, OnInit } from '@angular/core';
import { IktatgatoService } from '../iktatgato.service';
import { DataService } from '../../data.service';

/**
 *  BKSZ – Biztonságos Kézbesítési Szolgáltatás beállítása és próbája.
 *
 *  A „hivatali kapu" csak az egyik postafiók-típus a BKSZ-ben: cégkapuval és
 *  ügyfélkapu-tárhellyel is ugyanez a csatorna működik. A gépi kapcsolat
 *  kliens-tanúsítványos TLS-sel megy az IOPService2 végpontra.
 *
 *  A képernyő szándékosan lépésekre bontja a bekötést, mert így minden hiba ott
 *  derül ki, ahol keletkezett:
 *    1. tanúsítvány feltöltése   – jó-e a P12 és a jelszó
 *    2. saját postafiók           – KI a feladó (rövid név / KRID)
 *    3. kapcsolat próbája        – elfogadja-e a szolgáltatás a tanúsítványt
 *    4. kapcsolati kód lekérés   – helyes-e a KR-üzenet és a címzett adata
 *
 *  A 2. lépés külön áll a tanúsítványtól, mert két KÜLÖNBÖZŐ dolgot azonosít: a
 *  tanúsítvány a gépet, a rövid név / KRID a postafiókot, amelyről a küldemény megy.
 *  Ha ez hiányzik, a küldés akkor is elakad, ha a kézfogás tökéletes.
 */
@Component({
  selector: 'app-ikt-bksz',
  templateUrl: './bksz.component.html',
  styleUrls: ['../iktatgato-layout/iktatgato-layout.component.scss'],
})
export class IktBkszComponent implements OnInit {
  tanusitvanyok: any[] = [];
  feltoltes: any = { jelszo: '' };
  feltoltesFut = false;

  sajat: any = {
    rovidnev: '', krid: '', kapu_tipus: 'hivatali_kapu', vegpont: '',
    kornyezet: 'eles', hagyomanyos: false, ipsec: false,
    wss_jelszo: '', wss_jelszo_beallitva: false,
    doktipus: { hivatal: '', azonosito: '', leiras: '' },
    // Küldési mód – lásd a `modLeiras` magyarázatát.
    mod: 'direkt', rele_url: '', rele_azonosito: '', rele_kulcs: '', rele_kulcs_beallitva: false,
  };
  sajatFut = false;

  /*  KÜLDÉSI MÓD.
   *
   *  A BKSZ gépi végpontja FORRÁS-CÍM szerint enged: a szolgáltatónál be kell
   *  jelenteni, melyik IP-ről érkezhet a kapcsolat. Ha a szervezetnek nincs állandó
   *  IP-je – vagy a bejelentés eleve a központi szerverre szól –, a küldést nem ez a
   *  telepítés végzi, hanem a központi relé, és a tanúsítvány is ott van.
   */
  readonly modok = [
    { id: 'direkt', cim: 'Közvetlen (erről a szerverről)' },
    { id: 'rele', cim: 'Központi relén keresztül' },
  ];

  get releMod() { return this.sajat.mod === 'rele'; }

  tesztFut = false;
  teszt: any = null;

  // A WS-Security a RÖVIDNÉVVEL azonosít, nem a KRID-del – ezért az megy feladóként.
  kapcsolat: any = { kuldo_rovidnev: '', partner_id: '', keres_visszaadas: true };
  szemely: any = { nev: '', szuletesi_nev: '', anyja_neve: '', szul_hely: '', szul_ido: '' };
  partnerek: any[] = [];
  kodFut = false;
  kodEredmeny: any = null;

  nyers: any = { xml: '', soap_action: '' };
  nyersFut = false;
  nyersEredmeny: any = null;
  nyersNyitva = false;

  /*  A DOKUMENTÁLT VÉGPONTOK – NISZ BKSZ Interfész Specifikáció v3.4.
   *
   *  Azért van itt is, hogy a képernyő ki tudja írni, MELYIK címre fog menni a hívás,
   *  még mentés előtt. A hivatali kapué szándékosan sima http:// IP-cím: az NTG zárt
   *  hálózatán belül érhető el, nem a nyílt interneten.
   */
  readonly VEGPONTOK: any = {
    hivatali_kapu: {
      eles: 'http://84.206.24.94/kr_esb_gateway/services/IOPService2/process',
      teszt: 'http://84.206.8.91/kr_esb_gateway/services/IOPService2/process',
    },
    cegkapu: {
      eles: 'https://ckpgi.gov.hu/kr_esb_gateway/services/IOPService2/process',
      teszt: 'https://ckpgi.teszt.gov.hu/kr_esb_gateway/services/IOPService2/process',
    },
    perkapu: {
      eles: 'https://pkpgi.gov.hu/kr_esb_gateway/services/IOPService2/process',
      teszt: 'https://pkpgi.teszt.gov.hu/kr_esb_gateway/services/IOPService2/process',
    },
  };

  /*  A HAGYOMÁNYOS azonosításnak SAJÁT végpontja van: `IOPService`, kettes nélkül.
   *  A specifikáció csak hivatali kapura adja meg – cégkapunál és perkapunál nincs
   *  ilyen út, ott csak a WS-Security-s IOPService2 létezik. */
  readonly VEGPONTOK_HAGYOMANYOS: any = {
    eles: 'http://84.206.24.94/kr_esb_gateway/services/IOPService/process',
    teszt: 'http://84.206.8.91/kr_esb_gateway/services/IOPService/process',
  };

  get VEGPONT() {
    const teszt = this.sajat.kornyezet === 'teszt';
    if (this.hagyomanyosLehet && this.sajat.hagyomanyos) {
      return teszt ? this.VEGPONTOK_HAGYOMANYOS.teszt : this.VEGPONTOK_HAGYOMANYOS.eles;
    }
    const k = this.VEGPONTOK[this.sajat.kapu_tipus] || this.VEGPONTOK.hivatali_kapu;
    return teszt ? k.teszt : k.eles;
  }

  /** Hagyományos azonosítás csak hivatali kapunál létezik. */
  get hagyomanyosLehet() { return this.sajat.kapu_tipus === 'hivatali_kapu'; }

  /** A hivatali kapu NTG-s: nyílt internetről IP-engedélyezéssel sem érhető el. */
  get ntgKell() { return this.sajat.kapu_tipus === 'hivatali_kapu'; }

  /*  A kapu típusának váltása kizárja a hagyományos utat: cégkapunál/perkapunál nincs
   *  ilyen végpont. Ha bekapcsolva maradna, a mentett beállítás egy nem létező címre
   *  mutatna – és a hiba úgy nézne ki, mintha a szolgáltatás nem válaszolna. */
  kapuValtozott() {
    if (!this.hagyomanyosLehet) this.sajat.hagyomanyos = false;
  }

  constructor(private ikt: IktatgatoService, private data: DataService) {}

  /*  A BEÉRKEZŐ KÜLDEMÉNYEK LISTÁJA ÁTKÖLTÖZÖTT a saját menüpontjába
   *  (`/iktatgato/kuldemenyek`): ez a képernyő a kapcsolat beállítása, azt egyszer
   *  állítja be a rendszergazda – a postafiókot viszont naponta nézi az ügyintéző. */

  async ngOnInit() {
    await this.betolt();
    await this.sajatBetolt();
    try {
      this.partnerek = (await this.ikt.partnertorzs({ tipus: 'szemely' })).filter((p: any) => !p.kapu_hiany?.length);
    } catch { this.partnerek = []; }
  }

  async betolt() {
    try { this.tanusitvanyok = await this.ikt.bkszTanusitvanyok(); }
    catch { this.tanusitvanyok = []; }
  }

  get kijelolt() { return this.tanusitvanyok.find((t) => t.hkp); }

  /*  MI KELL EHHEZ A CSATLAKOZÁSHOZ – A SPECIFIKÁCIÓ SZERINT.
   *
   *  A képernyő eddig két dolgot kínált (WSS jelszó VAGY „hagyományos" azonosítás), és
   *  ebből nem derült ki, hogy ezek NEM egyenrangú alternatívák: a tanúsítványos,
   *  interneten át elérhető végponton CSAK a WS-Security út él, a „hagyományos" pedig
   *  kizárólag NTG/IPSec kapcsolaton, más címeken. Aki fix IP-vel és tanúsítvánnyal
   *  csatlakozott, de WSS jelszót nem kapott, így zsákutcába futott: bármit kattintott,
   *  vagy jelszót kértünk tőle, vagy egy elérhetetlen címre küldtük.
   *
   *  Ez a lista ezért a HÁROM tényleges feltételt mutatja, és azt, melyik hiányzik.
   */
  get feltetelek(): Array<{ kesz: boolean; cim: string; leiras: string }> {
    const certKell = !this.sajat.ipsec && this.sajat.mod === 'direkt';
    const lista = [
      {
        kesz: true,
        cim: 'Fix kimenő IP bejelentve a szolgáltatónál',
        leiras: 'A BKSZ gépi végpontja forrás-cím szerint enged. Ezt innen nem tudjuk ellenőrizni: '
          + 'a kapcsolat-ellenőrzés mondja meg, ha a végpont néma – a szerver kimenő IP-je ott látszik.',
      },
    ];
    if (certKell) {
      lista.push({
        kesz: !!this.kijelolt,
        cim: 'Kliens-tanúsítvány feltöltve és kijelölve',
        leiras: this.kijelolt
          ? `Kijelölve: ${this.kijelolt.nev || this.kijelolt.fajlnev || 'tanúsítvány'}.`
          : 'A publikus HTTPS-végponthoz a spec szerint „a kliens oldal azonosításához szükséges '
            + 'tanúsítvánnyal kell rendelkezni". Töltsd fel lent, és jelöld ki hivatali kapuhoz.',
      });
    }
    lista.push({
      kesz: !!(this.sajat.wss_jelszo_beallitva || this.sajat.wss_jelszo?.trim() || this.sajat.hagyomanyos),
      cim: this.sajat.hagyomanyos
        ? 'Azonosítás jelszó nélkül (IOPService)'
        : 'WS-Security jelszó megadva',
      leiras: this.sajat.hagyomanyos
        ? 'Jelszó nélküli mód: a hívás az IOPService szolgáltatásra megy (kettes nélkül), a '
          + 'szervezetet a rövidnév azonosítja az üzenetben, a hitelesítést pedig a HÁLÓZATI ÚT '
          + 'adja – kliens-tanúsítvány + fix IP, vagy NTG/IPSec. A hivatalos NISZ mintakliens is '
          + 'így dönt: jelszó nélkül IOPService, jelszóval IOPService2.'
        : 'A tanúsítvány a HÁLÓZATBA enged be; az üzenetet ettől külön a WS-Security jelszó '
          + 'azonosítja (rövidnév + jelszó). Ezt a csatlakozáskor adja ki az IdomSoft a postafiók '
          + 'azonosítóval és a KRID-del együtt. Ha nem kaptál jelszót, kapcsold be alább a jelszó '
          + 'nélküli módot.',
    });
    return lista;
  }

  /*  MELYIK SZOLGÁLTATÁST HÍVJUK? A hivatalos NISZ mintakliens szerint ez KIZÁRÓLAG
   *  azon múlik, van-e jelszó: jelszó nélkül `IOPService`, jelszóval `IOPService2`. */
  get szolgaltatasNeve(): string {
    return this.sajat.hagyomanyos ? 'IOPService' : 'IOPService2 (WS-Security)';
  }

  /* ── 2. saját postafiók (feladó) ── */

  async sajatBetolt() {
    try {
      const r = await this.ikt.bkszSajat();
      this.sajat = {
        rovidnev: r?.rovidnev || '', krid: r?.krid || '',
        kapu_tipus: r?.kapu_tipus || 'hivatali_kapu', vegpont: r?.vegpont || '',
        kornyezet: r?.kornyezet === 'teszt' ? 'teszt' : 'eles',
        hagyomanyos: !!r?.hagyomanyos,
        //  Régi, IPSec/NTG-s út: ettől függ, melyik (mai vagy kivezetés alatti) címre megy a hívás.
        ipsec: !!r?.ipsec,
        // A WS-Security jelszó sosem jön vissza a szervertől – csak az, hogy be van-e
        // állítva. Az üres mező tehát „marad a mostani", nem „töröld".
        wss_jelszo: '', wss_jelszo_beallitva: !!r?.wss_jelszo_beallitva,
        doktipus: {
          hivatal: r?.doktipus?.hivatal || '',
          azonosito: r?.doktipus?.azonosito || '',
          leiras: r?.doktipus?.leiras || '',
        },
        mod: r?.mod === 'rele' ? 'rele' : 'direkt',
        rele_url: r?.rele_url || '', rele_azonosito: r?.rele_azonosito || '',
        // A megosztott kulcs sosem jön vissza a szervertől – csak az, hogy be van-e
        // állítva. Az üres mező tehát „marad a mostani", nem „töröld".
        rele_kulcs: '', rele_kulcs_beallitva: !!r?.rele_kulcs_beallitva,
      };
      // A lekérdező űrlap ugyanezt a feladót használja: ne kelljen kétszer beírni.
      if (!this.kapcsolat.kuldo_rovidnev) this.kapcsolat.kuldo_rovidnev = r?.rovidnev || '';
    } catch { /* még nincs beállítva – üres marad */ }
  }

  /** A ténylegesen használt cím: a beállított, ha van – különben a beépített alapérték. */
  get hasznaltVegpont() { return this.sajat.vegpont?.trim() || this.VEGPONT; }

  async sajatMent() {
    if (!this.sajat.rovidnev?.trim()) {
      this.data.sendToast('A rövid nevet meg kell adni – a WS-Security ezzel azonosít.', 'warning');
      return;
    }
    if (this.releMod) {
      if (!this.sajat.rele_url?.trim() || !this.sajat.rele_azonosito?.trim()) {
        this.data.sendToast('Relé módhoz a relé címe és a telepítés-azonosító is kell.', 'warning');
        return;
      }
      if (!this.sajat.rele_kulcs?.trim() && !this.sajat.rele_kulcs_beallitva) {
        this.data.sendToast('Add meg a relétől kapott megosztott kulcsot.', 'warning');
        return;
      }
    }
    this.sajatFut = true;
    try {
      const r = await this.ikt.bkszSajatMent(this.sajat);
      this.kapcsolat.kuldo_rovidnev = r?.rovidnev || this.kapcsolat.kuldo_rovidnev;
      // A beírt kulcsot azonnal elfelejtjük: nincs okunk a képernyőn tartani.
      this.sajat.rele_kulcs = '';
      this.sajat.rele_kulcs_beallitva = !!r?.rele_kulcs_beallitva;
      this.sajat.wss_jelszo = '';
      this.sajat.wss_jelszo_beallitva = !!r?.wss_jelszo_beallitva;
      this.data.sendToast('Saját postafiók elmentve.');
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A mentés nem sikerült.', 'error');
    } finally {
      this.sajatFut = false;
    }
  }

  /*  A RÖVIDNÉV a kötelező: a WS-Security ezzel azonosít („a <wsse:Username> a hivatal
   *  mindenkori rövidneve"), a KRID önmagában nem elég. */
  get sajatKesz() { return !!this.sajat.rovidnev?.trim(); }

  get wssKesz() {
    return !!(this.sajat.wss_jelszo?.trim() || this.sajat.wss_jelszo_beallitva || this.sajat.hagyomanyos);
  }

  /* ── 1. tanúsítvány ── */

  fajlValasztva(esemeny: any) {
    const fajl: File = esemeny?.target?.files?.[0];
    if (fajl) this.feltolt(fajl, esemeny.target);
  }

  async feltolt(fajl: File, input?: any) {
    this.feltoltesFut = true;
    try {
      const r = await this.ikt.bkszTanusitvanyFeltolt(fajl, this.feltoltes.jelszo);
      this.data.sendToast(`Feltöltve: ${r.tulajdonos || r.nev} (érvényes ${r.ervenyes_ig}-ig)`, 'success');
      this.feltoltes.jelszo = '';
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A feltöltés nem sikerült.', 'error');
    } finally {
      this.feltoltesFut = false;
      if (input) input.value = '';
    }
  }

  async kijelol(t: any) {
    try {
      await this.ikt.bkszTanusitvanyKijelol(t.id);
      this.data.sendToast('Kijelölve BKSZ célra.');
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A kijelölés nem sikerült.', 'error');
    }
  }

  /* ── 3. kapcsolat ── */

  /**
   *  Mindkét módban kell KIJELÖLT tanúsítvány, csak más szerepben:
   *  közvetlen módban a BKSZ felé megy, relé módban a relé felé – ott az azonosít.
   */
  get probalhato() { return this.sajatKesz && (!this.releMod || !!this.sajat.rele_url); }

  async kapcsolatProba() {
    this.tesztFut = true;
    this.teszt = null;
    try {
      this.teszt = await this.ikt.bkszTeszt();
    } catch (e: any) {
      // A szerver valódi üzenetét mutatjuk. Az általános „nem futott le" semmit nem
      // mond arról, hogy nálunk kell-e javítani vagy a szolgáltatónál.
      //
      // A 0 / 502 / 504 külön eset: ilyenkor a VÁLASZ nem ért célba (a fordított proxy
      // elvágta), tehát nem a BKSZ-ről tudunk meg semmit. Ezt meg is mondjuk, különben
      // a felhasználó a tanúsítványát kezdi keresgélni egy hálózati hiba miatt.
      const kod = Number(e?.status || 0);
      this.teszt = {
        hiba: [0, 502, 503, 504].includes(kod)
          ? `A kérés nem ért célba (${kod || 'megszakadt kapcsolat'}). `
            + 'A próba maga a kiszolgálón fut; ha ez ismétlődik, a webkiszolgáló '
            + 'időkorlátja vágja el a választ – próbáld újra.'
          : (e?.error?.error || e?.message || 'A próba nem futott le.'),
      };
    } finally {
      this.tesztFut = false;
    }
  }

  /** A diagnózis fejléce: a kérdés mindig az, hogy kinél kell intézkedni. */
  diagnozisCim(ertelmezes: string) {
    return {
      a_szolgaltatonal: 'A tanúsítvány még nincs élesítve a szolgáltatónál',
      halozat: 'A szolgáltatás nem érhető el erről a szerverről',
      nalunk: 'Nálunk kell javítani',
      ismeretlen: 'A hiba nem sorolható be egyértelműen',
    }[ertelmezes] || 'Eredmény';
  }

  masol(szoveg: string) {
    navigator.clipboard?.writeText(String(szoveg || ''))
      .then(() => this.data.sendToast('Vágólapra másolva.'))
      .catch(() => { /* csendben marad: a szöveg kijelölhető kézzel is */ });
  }

  /* ── 4. kapcsolati kód ── */

  async kapcsolatiKod() {
    if (!this.kapcsolat.kuldo_rovidnev?.trim() && !this.sajatKesz) {
      this.data.sendToast('Előbb add meg a saját postafiókot (2. lépés).', 'warning');
      return;
    }
    this.kodFut = true;
    this.kodEredmeny = null;
    try {
      const adat: any = { ...this.kapcsolat };
      if (!adat.partner_id) { delete adat.partner_id; adat.szemely = this.szemely; }
      this.kodEredmeny = await this.ikt.bkszKapcsolatiKod(adat);
    } catch (e: any) {
      this.kodEredmeny = { hiba_szoveg: e?.error?.error || 'A lekérés nem futott le.' };
    } finally {
      this.kodFut = false;
    }
  }

  /*  ── DOLGOZÓK KAPCSOLATI KÓDJAI ──────────────────────────────────────────
   *
   *  A fenti blokk EGY emberre kérdez rá. A napi kérdés viszont az, hogy a
   *  BÉRJEGYZÉK-kiküldés előtt kinél hiányzik a kód – ezt eddig csak személyenként,
   *  próbálkozással lehetett kideríteni.
   *
   *  A lekérés nem mindig jár sikerrel (aki nincs regisztrálva a tárhelyre, annak nincs
   *  is kódja), ezért a KÉZI megadás is kell: aki máshonnan megkapta, be tudja írni. */
  dolgozoKodok: any[] = [];
  kodokFut = false;
  kodSorFut = '';

  async dolgozoKodokBetolt() {
    this.kodokFut = true;
    try {
      const r = await this.ikt.bkszKapcsolatiKodok();
      this.dolgozoKodok = (Array.isArray(r) ? r : []).map((p: any) => ({ ...p, uj_kod: p.kapcsolati_kod || '' }));
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A lista nem tölthető be.', 'error');
    } finally {
      this.kodokFut = false;
    }
  }

  get kodHiany(): number { return this.dolgozoKodok.filter((p) => !p.kapcsolati_kod).length; }

  async kodLekerEgy(p: any) {
    if (p.hiany?.length) {
      this.data.sendToast(`Hiányzó azonosító adat: ${p.hiany.join(', ')}. A törzsadatban pótolható.`, 'warning');
      return;
    }
    this.kodSorFut = p.id;
    try {
      const r: any = await this.ikt.bkszKapcsolatiKod({ partner_id: p.id });
      if (r?.kapcsolati_kod) {
        p.kapcsolati_kod = r.kapcsolati_kod;
        p.uj_kod = r.kapcsolati_kod;
        p.uzenet = `Lekérve${r.talalt_nev ? ` – a szolgáltatás szerint: ${r.talalt_nev}` : ''}`;
      } else {
        p.uzenet = r?.hiba
          ? `${r.hiba.kod ? r.hiba.kod + ' – ' : ''}${r.hiba.szoveg || ''}`.trim()
          : 'A szolgáltatás nem adott kódot – ez jellemzően azt jelenti, hogy az illető '
            + 'nincs regisztrálva a tárhelyre. Ilyenkor a kódot kézzel kell beírni.';
      }
    } catch (e: any) {
      p.uzenet = e?.error?.error || 'A lekérés nem futott le.';
    } finally {
      this.kodSorFut = '';
    }
  }

  async kodMentEgy(p: any) {
    try {
      const r: any = await this.ikt.bkszKapcsolatiKodMentes(p.id, String(p.uj_kod || '').trim());
      p.kapcsolati_kod = r?.kapcsolati_kod || null;
      p.uzenet = r?.kapcsolati_kod ? 'Kézzel megadva és elmentve.' : 'A kód törölve.';
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A mentés nem sikerült.', 'error');
    }
  }

  /*  Sorban, nem párhuzamosan: a szolgáltatás gépi végpontja nem verseny, és egy
   *  elakadásnál látni kell, melyik embernél állt meg. */
  async kodLekerMind() {
    const cel = this.dolgozoKodok.filter((p) => !p.kapcsolati_kod && !p.hiany?.length);
    if (!cel.length) { this.data.sendToast('Nincs olyan dolgozó, akinél lekérhető volna.', 'warning'); return; }
    if (!confirm(`${cel.length} dolgozónál kérjük le a kapcsolati kódot. Ez percekig tarthat. Folytatod?`)) return;
    this.kodokFut = true;
    try {
      for (const p of cel) await this.kodLekerEgy(p);
      const megvan = cel.filter((p) => p.kapcsolati_kod).length;
      this.data.sendToast(`${megvan} / ${cel.length} kód megvan.`, megvan ? 'success' : 'warning');
    } finally {
      this.kodokFut = false;
    }
  }

  /** A kiválasztott partner adatai a kézi mezőkbe, hogy látszódjon, mivel kérdezünk. */
  partnerValt() {
    const p = this.partnerek.find((x) => x.id === this.kapcsolat.partner_id);
    if (!p) return;
    this.szemely = {
      nev: p.nev, szuletesi_nev: p.szuletesi_nev, anyja_neve: p.anyja_neve,
      szul_hely: p.szul_hely, szul_ido: p.szul_ido,
    };
  }

  /* ── nyers üzenet ── */

  async nyersKuldes() {
    if (!this.nyers.xml?.trim()) { this.data.sendToast('Nincs elküldendő XML.', 'warning'); return; }
    this.nyersFut = true;
    this.nyersEredmeny = null;
    try {
      this.nyersEredmeny = await this.ikt.bkszNyers(this.nyers.xml, this.nyers.soap_action);
    } catch (e: any) {
      this.nyersEredmeny = { error: e?.error?.error || 'A küldés nem futott le.' };
    } finally {
      this.nyersFut = false;
    }
  }
}
